import React, { useState } from "react";
import Bank from "../../../assets/images/bank.png";
import Upi from "../../../assets/images/upi.png";
import Paytm from "../../../assets/images/paytm.png";
import Amazon from "../../../assets/images/amazon.png";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate, useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layout/Header";
export const SelectPayment = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { lang } = useParams();
  const myRewardsData = useSelector((state) => state.myRewardsData);
  const dispatch = useDispatch();
  const viewPaymentOptions = myRewardsData?.cbTransactionList?.paymentOptions;

  // const handleBankClick = () => {
  //   // debugger;
  //   ReactGA.event({
  //     category: 'User Bank Payment',
  //     action: 'CLK_BANK_MODE'
  //   });
  //   navigate(`/${lang}/bankdetails`);
  // }

  // const handleUPIClick = () => {
  //   //  debugger;
  //   ReactGA.event({
  //     category: 'User UPI Payment',
  //     action: 'CLK_UPI_MODE'
  //   });
  //   navigate(`/${lang}/upidetails`);
  // }

  const handleBankClick = () => {
    // debugger;
    ReactGA.event({
      category: 'btn',
      action: 'Bank Payment Mode Clicked',
      label: 'Select Payment Method'
    });
    navigate(`/${lang}/bankdetails`);
  }

  const handleUPIClick = (type) => {
    ReactGA.event({
      category: 'btn',
      action: 'UPI Payment Mode Clicked',
      label: 'Select Payment Method'
    });
    navigate(`/${lang}/upidetails`, {
      state: { type }
    });
  };

  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <Accordion.Header id="transfer">
              <div>
                <i
                  className="fa fa-chevron-left text-white mr-2"
                  onClick={() => {
                    ReactGA.event({
                      category: 'btn',
                      action: 'Back Button Clicked',
                      label: 'Select Payment Method'
                    });
                    navigate(`/${lang}/home`)
                  }}
                ></i>
                {t("transfer")}
              </div>
            </Accordion.Header>
            <div className="card-body px-2 pt-0 pb-2">
              <div className="px-4 py-2 mt-4">
                <p className="infoText mb-0">{t("paymentMode")}</p>
                <hr className="mt-2" />
                <div className="mt-4">

                  {/* viewPaymentOptions */}

                  {viewPaymentOptions?.map(
                    (item, index) =>
                      item.toLowerCase() === "bank details" && (
                        <>
                          <div onClick={handleBankClick} key={index}>
                            <img src={Bank} alt="Bank" className="d-block m-auto" />
                          </div>
                          <hr className="mt-2" />
                        </>
                      )
                  )}

                  {viewPaymentOptions?.map(
                    (item, index) =>
                      item.toLowerCase() === "upi" && (
                        <>
                          <div onClick={() => handleUPIClick(item)} key={index}>
                            <img src={Upi} alt="Upi" className="d-block m-auto" />
                          </div>
                          <hr className="mt-2" />
                        </>
                      )
                  )}

                  {viewPaymentOptions?.map(
                    (item, index) =>
                      item.toLowerCase() === "paytm" && (
                        <>
                          <Link to="/paytmdetails" key={index}>
                            <img src={Paytm} alt="Paytm" className="d-block m-auto" />
                          </Link>
                          <hr className="mt-2" />
                        </>
                      )
                  )}

                  {viewPaymentOptions?.map(
                    (item, index) =>
                      item.toLowerCase() === "amazon pay gift card" && (
                        <>
                          <Link to="/amazondetails" key={index}>
                            <img src={Amazon} alt="Amazon" className="d-block m-auto" />
                          </Link>
                          <hr className="mt-2" />
                        </>

                      )
                  )}

                  {viewPaymentOptions?.map(
                    (item, index) =>
                      item.toLowerCase() === "upilinkedmobno" && (
                        <div onClick={() => handleUPIClick(item)} key={index}>
                          <img src={Upi} alt="Upilinkedmobno" className="d-block m-auto" />
                        </div>
                      )
                  )}


                  {/* <div onClick={handleBankClick}>
                    <img src={Bank} alt="Bank" className="d-block m-auto" />
                  </div>
                  <hr className="mt-2" />
                  <div onClick={handleUPIClick}>
                    <img src={Upi} alt="Upi" className="d-block m-auto" />
                  </div>
                  <hr className="mt-2" /> */}
                  {/* <Link to="/paytmdetails">
                    <img src={Paytm} alt="Paytm" className="d-block m-auto" />
                  </Link>
                  <hr className="mt-2" />
                  <Link to="/amazondetails">
                    <img src={Amazon} alt="Amazon" className="d-block m-auto" />
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
